<template>
  <!-- 公开课 -->
  <div class="gongkaike">
    <div class="gongkaike-content" v-if="listdata.length > 1">
      <div class="gongkaike-left">
        <div class="gongkaike-left-title">美课公开课</div>
        <div class="gongkaike-left-box" v-for="(item,i) in listdata" :key="i" v-if="i == 0" @click="toDetails(item)">
          <div class="gongkaike-left-boxImg">
            <img :src="item.thumb" alt="美课教育公开课">
          </div>
          <div class="gongkaike-left-text">
            <p>{{item.title}}</p>
            <div class="tiyan_img">
              <img v-if="compareTime(item.start_time_true) == 2" src="@/assets/img2.png" alt="" class="zhibozhong">
              <img v-if="compareTime(item.start_time_true) == 1" src="@/assets/zhibozhong.gif" alt="" class="zhibozhong">
            </div>
            <div class="tiyan_bottom">
              <div class="tiyan_bottom_time">
                <img src="@/assets/img3.png" alt="">
                <span>直播时间：{{item.start_time}}</span>
              </div>
              <div class="tiyan_bottom_teacher">
                <img src="@/assets/img4.png" alt="">
                <span>讲师：{{item.teacher.name}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="gongkaike-right">
        <div class="gongkaike-right-title">课程预告</div>
        <div class="gongkaike-right-box">
          <div class="tiyanke_right_li" v-for="(item,i) in listdata" :key="i" v-if="i>0">
            <img :src="item.thumb" alt="">
            <div class="tiyan_right_box">
              <span class="tiyan_right_time"></span>
              <div style="text-align: left;">
                <span class="tiyan_right_time">{{item.start_time}} - {{item.end_time}}</span>
                <h4 v-if="compareTime(item.start_time_true) == 1">直播中</h4>
                <h4 v-if="compareTime(item.start_time_true) == 2">未开始</h4>
              </div>
              <div class="tiyan_right_box_bottom">{{item.title}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import slider components
  export default {
    name: 'lecture',
    data() {
      return {
        listdata: [],
        nowTime: 0
      }
    },
    created() {
      this.getlist()
    },
    methods: {
      compareTime(date) {
        if (!date) {
          return ""
        } else {
          const Date1 = date*1000; // 课程开始时间
          const Date2 = Date.now() // 现在时间
          if (Date1 < Date2) {
            return 1; // 进行中
          } else {
            return 2; // 未开始
          }
        }
      },
      getlist() {
        this.$axios({
          method: 'post', // 请求格式
          url: '/api/course/coursePublic', // 请求路径
          headers: { // 设置请求头
            token: this.$cookieStore.getCookie('token'),
          },
          data: {
            "category": ""
          }
        }).then(res => {
          this.listdata = res.data.data
        }).catch(err => {

        })
      },
      toDetails(data) {
        // let loading = this.compareTime(data['start_time_true'])
        // if (loading != 1) {
        //   this.$message.error('课程还没有开始哦，待会再来吧~')
        //   return;
        // }
        this.$router.push({
          path: "/live",
          query: {
            id: data.id
          }
        })
      }
    },
  }
</script>
<style scoped>
  /**********公开课 **********/
  .gongkaike {
    width: 100%;
    background-color: rgb(245, 247, 249);
  }

  .gongkaike-content {
    width: 1200px;
    padding: 100px 0 150px;
    box-sizing: border-box;
    margin: 0px auto;
    display: flex;
    justify-content: space-between;
  }

  /* gongkaike-right */
  .gongkaike-right {
    width: 298px;
  }

  .gongkaike-right-title {
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-align: left;
  }

  .gongkaike-right-box {
    background: #FFFFFF;
    box-shadow: 0px 0px 40px 0px rgb(204 204 204 / 35%);
    border-radius: 20px;
    margin: 70px 0 0 0;
    height: 395px;
    padding: 20px 20px 50px;
    box-sizing: border-box;
    display: flex;
    /* justify-content: space-between; */
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .tiyanke_right_li {
    width: 100%;
    display: flex;
    padding: 20px 0px;
    margin-top:10px;
    cursor: pointer;
  }

  .tiyanke_right_li h4 {
    color:#7A7A7A;
    font-weight:400;
  }

  .tiyanke_right_li img {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    object-fit: cover;
  }

  .tiyan_right_box {
    margin-left: 20px;
    width: calc(100% - 74px);
    box-sizing: border-box;
  }

  .tiyan_right_time {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: red;
  }

  .tiyan_right_box_bottom {
    width: 100%;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: left;
    /* margin: 0 0 0 6px; */
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
  }

  /* gongkaike-left */
  .gongkaike-left {
    width: 880px;
    cursor: pointer;
  }

  .gongkaike-left-title {
    font-size: 36px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    text-align: left;
  }

  .gongkaike-left-box {
    display: flex;
    justify-content: space-between;
    background-color: #fff;
    padding: 30px 0 30px 30px;
    margin: 70px 0 0 0;
    box-shadow: 0px 0px 40px 0px rgb(204 204 204 / 35%);
    border-radius: 20px;
    box-sizing: border-box;
  }

  .gongkaike-left-text {
    width: 350px;
    padding: 30px;
    box-sizing: border-box;
  }

  .gongkaike-left-text p {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .tiyan_bottom {
    margin: 40px 0 0 0;
    font-size: 16px;
    color: #333333;
  }

  .tiyan_bottom_teacher {
    margin-top: 26px;
    display: flex;
    align-items: center;
  }

  .tiyan_bottom_teacher img {
    margin-right: 10px;
    width: 17px;
    height: 17px;
  }

  .tiyan_bottom_time {
    display: flex;
    align-items: center;
  }

  .tiyan_bottom_time img {
    margin-right: 10px;
    width: 17px;
    height: 17px;
  }

  .tiyan_img {
    padding: 19px 0 30px 0;
    border-bottom: 1px solid #E2E2E2;
    text-align: left;
  }

  .zhibozhong {
    width: 134px;
    /* height: 37px; */
    cursor: pointer
  }

  .gongkaike-left-boxImg {
    width: 482px;
    height: 335px;
    cursor: pointer;
    border-radius: 15px;
    position: relative;
  }

  .gongkaike-left-boxImg img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/Homes/lecture.vue